import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'
import { useAuth } from './useAuth'
import type { OrgRole } from '@theseus/shared-ui/orgs'

export type UserOrgItem = {
  id: string
  name: string
  role: OrgRole
}

export function useUserOrgs() {
  const { user } = useAuth()

  const { data: orgs = [], isLoading } = useQuery({
    queryKey: ['user-orgs', user?.id],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('organization_members')
        .select('org_id, role, organizations(id, name)')
        .eq('user_id', user!.id)
        .is('deleted_at', null)

      if (error) {
        console.error('Failed to fetch user orgs:', error)
        throw error
      }

      return (data ?? []).map((m): UserOrgItem => {
        const org = m.organizations as unknown as { id: string; name: string }
        return {
          id: org.id,
          name: org.name,
          role: m.role as OrgRole,
        }
      })
    },
    enabled: !!user,
  })

  return { orgs, loading: isLoading }
}
